<template>
    <div>
        <b-modal
            id="modify-risk-rating-override-popup"
            ref="modal"
            title="Modify Risk Rating Override"
            size="sm"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            modal-class="hide-footer"
            :hide-header-close="loading"
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-risk-override">
                    <div class="col-md-12">
                        <h5 v-model="formData.criteria" class="mb-20">
                            {{ formData.criteria.code }}
                        </h5>
                    </div>
                    <br /><br />
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-1"
                            label="Override Rating"
                            label-for="rating"
                        >
                            <b-form-select
                                v-model="formData.rating"
                                class="form-control"
                                :options="rating"
                                autocomplete="no"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-4"
                            class="mb-0 kyc-status-radio overwrite-radio"
                            label="Is Rejected?"
                            label-for="rejected"
                        >
                            <b-form-group>
                                <b-form-radio-group
                                    v-model="formData.shouldReject"
                                    :options="shouldReject"
                                    name="rejected"
                                ></b-form-radio-group>
                            </b-form-group>
                        </b-form-group>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :btn-label="buttonLabel"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        :disabled="loading"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            formData: this.initializeFormData(),
            shouldReject: [
                { text: 'Yes', value: 'true' },
                { text: 'No', value: 'false' },
            ],
            rating: [
                { value: null, text: 'Select Rating', disabled: true },
                { value: 'high', text: 'High Risk' },
                { value: 'medium', text: 'Medium Risk' },
                { value: 'low', text: 'Low Risk' },
                { value: 'sanction', text: 'Sanctioned' },
            ],
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'hidePopup']),

        title() {
            return this.selectedItem
                ? 'Modify Risk Factor'
                : 'Add Country of Residence Factor'
        }, // End of title() method

        buttonLabel() {
            return this.selectedItem ? 'Update' : 'Create'
        },
    }, // End of Component > methods
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            if (value !== null && value !== undefined) {
                Object.assign(this.formData, value)
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                _id: null,
                criteria: {
                    code: '',
                    start: '',
                    end: '',
                },
            }
        }, // End of initializeFormData() method
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$store.commit('onSubmit', null)
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
        /**
         * Handle when the modal is canceled
         *
         * @return {void}
         */
        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    await this.$store.dispatch('onSubmit', this.formData)
                } catch (error) {
                    console.log(error, 'There is an error on submit')
                }
            }
        }, // End of onSubmit() method
    }, // End of Component > watch
}
</script>
